import React, {useState} from 'react';
import PropTypes from 'prop-types';
import UIUtils from 'services/UIUtils';
import DefaultReactSelect from 'components/Utils/DefaultReactSelect';
import './style.scss';
import {useAppDispatch} from "careand-redux/useAppDispatch";
import {api} from "careand-redux/api/ApiThunks";

const SearchAddress = props => {

  const dispatch = useAppDispatch();

  const [searchTimeout, setSearchTimeout] = useState(undefined);
  const [searchResults, setSearchResults] = useState([]);
  const [loading, setLoading] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  async function searchAddress(searchText, lastId) {
    if (!searchText && !lastId) return;

    setLoading(true);
    let result = await dispatch(api.Resource.searchAddress({searchText, lastId}));
    setLoading(false);
    if (result) {
      setSearchResults(result);
      setMenuOpen(true);
    }
  }

  async function retrieveAddress(id) {
    if (!id) return;

    setLoading(true);
    let result = await dispatch(api.Resource.retrieveAddress({id}));
    setLoading(false);
    if (result) {
      props.onSuccess(result);
    }
  }

  function onSearchChange(text) {
    clearTimeout(searchTimeout);
    let timeout = setTimeout(async () => {
      if (text && text !== '' && text.length > 2) {
        await searchAddress(text);
      }
    }, UIUtils.SEARCH_TYPE_TIMEOUT);
    setSearchTimeout(timeout);
  }

  function clickedAddress(value) {
    let next = value.Next;

    switch (next) {
      case 'Find':
        return searchAddress(value.Text, value.Id);
      case 'Retrieve':
        return retrieveAddress(value.Id);
      default:
        return;
    }
  }

  return (
    <div className={`search-address ${props.className || ""}`} style={props.style}>
      <DefaultReactSelect
        filterOption={() => true}
        loading={loading}
        menuIsOpen={menuOpen}
        setMenuOpen={setMenuOpen}
        placeholder="Search Address..."
        onChange={item => clickedAddress(item.value)}
        onInputChange={onSearchChange}
        options={dataToOptions(searchResults)}
        style={props.style}
      />
    </div>
  );
};

function dataToOptions(data = [], nameFields = ['Text', 'Description']) {
  return data.map(value => {
    let label = nameFields.map(field => value[field]).join(' - ');
    return {value, label};
  });
}

SearchAddress.propTypes = {
  onSuccess: PropTypes.func,
  style: PropTypes.object,
  className: PropTypes.string
};

export default SearchAddress;
